import store from '../store/index'
//------------------------
// get character by index
//------------------------
export default function getCharacterByIndex(deletion_index) {
  console.log('---------------------------------')
  console.log('getCharacterByIndex called with index: ', deletion_index)
  var character = null
  //--------------
  // access store
  //--------------
  const this_store = store.state.characters
  console.log('this_store =', this_store)
  console.log('this_store.characters =', this_store.characters)
  //------------------------------------------
  // get character deletion slug (for return)
  //------------------------------------------
  character = this_store.characters[deletion_index]
  console.log('deleting character: ', character)
  //---------
  // returns
  //---------
  return character
}
